import React, { useState } from "react";
import styles from "./values.module.scss";
import cx from "classnames";
import Tooltip from "src/components/tooltip";
import _ from "lodash";
import ContactDetailsSlideView from "src/legacy/components/Contacts/ContactDetails/ContactDetailsSlideview";


interface EmailTagViewProps {
  option: any;
  onRemove?: (value: any) => void;
  hideRemoveIcon?: boolean;
}

const EmailTagView: React.FC<EmailTagViewProps> = ({option, onRemove, hideRemoveIcon  }) => {
  const [selectedContact, setSelectedContact] = useState(null);
  const isLiteApp = window.location.pathname.startsWith("/lite");

  const handleRemoveTag = () => {
    if (onRemove) {
      onRemove(option.value);
    }
  };

  const showContactsView = (recipientContact) => {
    setSelectedContact(recipientContact);
  };

  let options = option;
  let value: { doNotDisturb?: boolean } = {};
  let validOption = false;
  let dnd = false;

  if (!Array.isArray(options)) {
    options = [options];
  }

  options.forEach((opt) => {
    value = opt.value;
    validOption = opt.valid;
    dnd = value?.doNotDisturb ?? false;
  });

  const renderOption = (tag) => {
    if (tag.entityType === "contact") {
      return renderContact(tag);
    } else if (tag.entityType === "contact_list") {
      return renderContactList(tag);
    } else {
      return renderDefault(tag);
    }
  };

  const renderContact = (contact) => (
    <span className={styles.value}>
      <i className="paperflite-user-settings" aria-hidden="true"></i>
      <Tooltip placement='bottom' content={contact.doNotDisturb ? "This contact has enabled DND" : ""}>
        <a
          data-for="dndtooltip"
          data-tip={contact.doNotDisturb ? "This contact has enabled DND" : ""}
          data-class={styles.dndToolTip}
          onClick={() => showContactsView(contact)}
          className={styles.link}
          style={{ pointerEvents: isLiteApp ? "none" : "auto" }}
        >
          {renderName(contact)}
        </a>
      </Tooltip>
    </span>
  );

  const renderContactList = (contactList) => (
    <span className={styles.value}>
      <i className="paperflite-group" aria-hidden="true"></i>
      <a
        href={`${window.location.origin}/settings/contact_list/${contactList.id}`}
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {contactList.name}
      </a>
    </span>
  );

  const renderName = (contact) => `${contact.firstName || ""}${contact.lastName ? ` ${contact.lastName}` : ""}`;

  const renderDefault = (tag) => (
    <span className={cx(styles.value)}>
      <i className="paperflite-mail" aria-hidden="true"></i>
      {tag}
    </span>
  );

  return (
    <div>
      <div className={cx(styles.tag, { [styles.error]: !validOption }, { [styles.dnd]: dnd })}>
        {renderOption(value)}

        {!hideRemoveIcon && (
        <span className={styles.remove} onClick={handleRemoveTag}>
          <i className="paperflite-close" aria-hidden="true"></i>
        </span>
      )}
      </div>

      <ContactDetailsSlideView onClose={() => setSelectedContact(null)} selectedContact={selectedContact} />
    </div>
  );
};

export default EmailTagView;
